module.exports = __webpack_public_path__ + "media/promo/velle/images/background_fruits-947b85e1508ac1e5e115fc6b3769e5e9.png";